import Vue from 'vue'
import { LOG_MANAGEMENT, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [LOG_MANAGEMENT.STATE.LOGS]: null
}

const actions = {
  async [LOG_MANAGEMENT.ACTIONS.GET_LOG] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getAdminHost()}/log/errorsByPattern?${Vue.helpers.getQueryParamsString(model.params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })

    commit(LOG_MANAGEMENT.MUTATIONS.GET_LOG, resp.data)
  },
  async [LOG_MANAGEMENT.ACTIONS.CLEAR] ({ commit }) {
    commit(LOG_MANAGEMENT.MUTATIONS.CLEAR)
  }
}

const mutations = {
  [LOG_MANAGEMENT.MUTATIONS.GET_LOG] (state, model) {
    state[LOG_MANAGEMENT.STATE.LOGS] = model
  },
  [LOG_MANAGEMENT.MUTATIONS.CLEAR] (state) {
    state[LOG_MANAGEMENT.STATE.LOGS] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
